export default __webpack_public_path__ + "static/media/ShareholderMeetingVote.08f0a5c8.pdf";